import MobileTabsHeader from 'components/TabsHeader/MobileTabsHeader';
import { usePerms } from 'contexts/PermsContext';
import AuditLogsV2 from 'features/AuditLogs_v2/AuditLogs_v2.index';
import MembersTab from 'pages/Admin/Components/MembersTab';
import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { useSearchParams } from 'react-router-dom';
import TabsHeader from '../../components/TabsHeader/TabsHeader';
export default function Organization() {
  const [params, setParams] = useSearchParams();
  const perms = usePerms();
  const [tabs, setTabs] = useState([0]);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    setTabs(params.get('tab') ? [parseInt(params.get('tab'))] : [0]);
  }, []);

  //components go in here to display data
  const renderTab = () => {
    switch (params.get('tab')?.toLowerCase()) {
      case 'users':
        return (
          <MembersTab
            mousePosition={mousePosition}
            perms={perms}
            setMousePosition={setMousePosition}
            listOnly
            editableOrgName
          />
        );
      case 'audit logs':
        return <AuditLogsV2 />;
      default:
        return (
          <MembersTab
            mousePosition={mousePosition}
            perms={perms}
            setMousePosition={setMousePosition}
            listOnly
            editableOrgName
          />
        );
    }
  };

  return (
    <Container fluid className="d-flex flex-column h-100 w-100 pb-3">
      {/* header */}
      <div className="w-100 d-none d-lg-block">
        <TabsHeader
          onTabChange={(newTabArr) => setTabs([...newTabArr])}
          currentTabs={tabs}
          options={[{ option: 'Users' }, { option: 'Audit Logs' }]}
          styles={[{ backgroundColor: '#436c98' }]}
        />
      </div>
      <div className="w-100 d-block d-lg-none">
        <MobileTabsHeader options={[{ option: 'Users' }, { option: 'Audit Logs' }]} />
      </div>
      {/* content */}
      <div className="flex-grow-1 min-h-0 overflow-hidden">{renderTab()}</div>
    </Container>
  );
}
